import
  dayjs
from 'dayjs';

export class Weather {

  constructor(fields, city) {
    this.fields = fields;
    this.city = city;
  }

  mapToStandard = () => {

    return {
      city: this.city,
      icon: this.fields?.weather?.[0]?.icon,
      temperature: Math.floor(this.fields?.temp?.day),
      min: Math.floor(this.fields?.temp?.min),
      max: Math.floor(this.fields?.temp?.max),
      date: dayjs.unix(this.fields?.dt).format('ddd D-M').toUpperCase(),
      day: dayjs.unix(this.fields?.dt).format('ddd').toUpperCase(),
      humidity: Math.floor(this.fields?.humidity),
      windDirection: this.getWindDirection(Math.floor(this.fields?.wind_deg)),
      windSpeed: Math.floor(this.fields?.wind_speed),
      windDirectionLetter: this.getDirection(this.fields?.wind_deg)
    };
  }

  mapToStandardCurrent = () => {

    return {
      city: this.city,
      icon: this.fields?.weather?.[0]?.icon,
      temperature: Math.floor(this.fields?.temp),
      min: Math.floor(this.fields?.temp?.min),
      max: Math.floor(this.fields?.temp?.max),
      date: dayjs.unix(this.fields?.dt).format('ddd D-M').toUpperCase(),
      day: dayjs.unix(this.fields?.dt).format('ddd').toUpperCase(),
      humidity: Math.floor(this.fields?.humidity),
      windDirection: this.getWindDirection(Math.floor(this.fields?.wind_deg)),
      windSpeed: Math.floor(this.fields?.wind_speed),
      windDirectionLetter: this.getDirection(this.fields?.wind_deg)
    };
  }

  getDirection = (angle) => {

    let directions = [
      'N', 'NW', 'W', 'SW', 'S', 'SE', 'E', 'NE'
    ];
    return directions[Math.round(((angle %= 360) < 0 ? angle + 360 : angle) / 45) % 8];
  }

  getWindDirection = (angle) => {

    let directions = [
      0, 45, 90, 135, 180, 225, 270, 315
    ];

    return directions[Math.round(((angle %= 360) < 0 ? angle + 360 : angle) / 45) % 8];
  };
}